<template>
    <div class="md logo">
        <router-link :to="{path: '/index'}" :style="'background-image: url('+ getLOGOpath +')'" expect>{{ $t('site.noun.sitename') }}</router-link>
    </div>
</template>

<script>

    export default {
        computed: {
            getLOGOpath: function(){
                return process.env.BASE_URL +'images/logos/logo_major_white_02.png';
            }
        },
    }
</script>

<style scoped lang="scss">

    .md.logo {

        .lo.login & {

            a {
                margin: 0 auto;
            }
        }

        flex: 1;

        a {
            @extend %hide-text;
            display: block;
            width: 250px;
            padding-bottom: 32px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;

            @include media('pad') {
                width: 190px;
            }

            @include media('phone') {
                width: 150px;
            }
        }
    }
</style>
